import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollAppToTop } from '../utils/scrollAppToTop';

/**
 * Scroll to top on every client-side route change.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollAppToTop();
  }, [pathname]);

  return null;
};

export default ScrollToTop;
